export const CLOSE_RESPONSE_DIALOG = 'users/CLOSE_RESPONSE_DIALOG';

export const POST_AVAILABLE_USER = 'users/POST_AVAILABLE_USER';
export const POST_AVAILABLE_USER_SUCCESSED =
  'users/POST_AVAILABLE_USER_SUCCESSED';
export const POST_AVAILABLE_USER_FAILED = 'users/POST_AVAILABLE_USER_FAILED';
export const SET_PARAMS_LIST_OF_AVAILABLE_USER =
  'users/SET_PARAMS_LIST_OF_AVAILABLE_USER';
